import { jsx as _jsx } from "react/jsx-runtime";
import { useBlackList } from "../../hooks/useBlackList";
import InputNewMessage from "./InputNewMessage";
import { useAppSelector } from "../../hooks/hook";
import SearchMessages from "./SearchMessages";
//переписать inputnewmessage
const MessageInputField = ({ selectedChat }) => {
    const isSearchMessage = useAppSelector(state => state.app.isSearchMessage);
    const { myBlackList, guestBlackList } = useBlackList();
    if (isSearchMessage)
        return _jsx(SearchMessages, {});
    if (myBlackList || guestBlackList)
        return null;
    return (_jsx(InputNewMessage, { chatInfo: selectedChat }));
};
export default MessageInputField;
